import type { HovGainUpgradeMpTarget } from "@/features/hoverIdle/types";
import { isHovGainUpgradeCellIndex } from "@/features/hoverIdle/mpm/mpmHovGainUpgradeTargets";

export type MpWallAssignments =
  | { readonly kind: "unassigned" }
  | { readonly kind: "hov-target"; readonly index: number }
  | {
      readonly kind: "hov-gain-upgrade";
      readonly target: HovGainUpgradeMpTarget;
    };

export function normalizeMpWallAssignments(input: unknown): MpWallAssignments {
  if (input === null || typeof input !== "object") {
    return { kind: "unassigned" };
  }
  const source = input as Record<string, unknown>;
  const legacy = source.kind === undefined;
  const index = legacy ? source.hovTargetIndex : source.index;
  if (
    (legacy || source.kind === "hov-target") &&
    typeof index === "number" &&
    isHovGainUpgradeCellIndex(index + 1)
  ) {
    return { kind: "hov-target", index };
  }
  // Legacy saves can contain both categories; a valid Hov target takes priority.
  const target = legacy ? source.hovGainUpgradeTarget : source.target;
  if (legacy || source.kind === "hov-gain-upgrade") {
    if (target === "global") return { kind: "hov-gain-upgrade", target };
    if (target !== null && typeof target === "object") {
      const cell = target as Record<string, unknown>;
      if (
        cell.kind === "cell" &&
        typeof cell.index === "number" &&
        isHovGainUpgradeCellIndex(cell.index)
      ) {
        return {
          kind: "hov-gain-upgrade",
          target: { kind: "cell", index: cell.index },
        };
      }
    }
  }
  return { kind: "unassigned" };
}
